var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tube",
    transform: "translate(-60 -1.019)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_709",
    "data-name": "Ret\\xE2ngulo 709",
    width: 50,
    height: 49,
    rx: 14,
    transform: "translate(60 1.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_317714_video_youtube_icon",
    "data-name": "317714_video_youtube_icon",
    transform: "translate(70.063 10.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1662",
    "data-name": "Caminho 1662",
    d: "M29.574,8.836a7.183,7.183,0,0,0-1.187-3.165,4.121,4.121,0,0,0-2.993-1.348C21.214,4,14.943,4,14.943,4h-.014s-6.271,0-10.45.324A4.123,4.123,0,0,0,1.486,5.672,7.2,7.2,0,0,0,.3,8.836,51.33,51.33,0,0,0,0,13.993V16.41a51.312,51.312,0,0,0,.3,5.158,7.168,7.168,0,0,0,1.187,3.162,4.885,4.885,0,0,0,3.294,1.362c2.39.245,10.157.32,10.157.32s6.277-.011,10.458-.332a4.139,4.139,0,0,0,2.993-1.35,7.181,7.181,0,0,0,1.187-3.162,51.336,51.336,0,0,0,.3-5.158V13.994A51.336,51.336,0,0,0,29.574,8.836Z",
    transform: "translate(0 0)",
    fill: "#272f4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1663",
    "data-name": "Caminho 1663",
    d: "M12,10V21.206l9.338-5.6Z",
    transform: "translate(-0.794 -0.397)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d4fdf0ac25b3b8d2152cac056d2fff99.svg";
export { ForwardRef as ReactComponent };